// Parser for glycan tokens - converts glycan tokens into visjs nodes
// Version 0.1
// 07/06/2024

import lexChain from "./lexer.js";
import resmap from "../data/resdict.json";
import shapemap from "../data/shapedict.json";
import colourmap from "../data/colourdict.json";

function genSVG(shape, colour, Lconfig=false, network=false, selected=false, scale=100, outerColour="black")
{
      
    if (Lconfig) { //annotate L configurations
        let svg = shapemap[shape].replace('$fillcolour', colourmap[colour]).replace('$stroke-weight', selected ? '9' : '2.6667').replace('$scaling', 
        network ? 'width=\"148\" height=\"148\"' : `width=\"${scale.toString()}%\" height=\"${scale.toString()}%\" viewbox=\"0 0 148 148\"`).replace('$strokecolour', network ? 'black' : outerColour).replace('</g></svg>','</g><text x=\"78\" y=\"115\" font-size=\"75\" text-anchor=\"middle\" font-style=\\\"italic\\\" >L</text></svg>');
        return {img:"data:image/svg+xml;base64," + btoa(svg), svg:svg};
  } else {
    
  let svg = shapemap[shape].replace('$fillcolour', colourmap[colour]).replace('$stroke-weight', selected ? '9' : '2.6667').replace('$scaling', 
    network ? 'width=\"148\" height=\"148\"' : `width=\"${scale.toString()}%\" height=\"${scale.toString()}%\" viewbox=\"0 0 148 148\"`).replace('$strokecolour', network ? 'black' : outerColour);
  return {img:"data:image/svg+xml;base64," + btoa(svg), svg:svg};
  }
}

//should probably put this in the lexer
function formatString(string)
{   
    if(string.includes('→'))
    {
        let newString = string.replace(/-/g, '').replace(/→/g, '->').replace(/β/g, 'b').replace(/α/g,'a').trim();
        return newString;
    } else {
        return string;
    }
}

function parseString(string)
{
    let casperString = formatString(string);
    const lexedChain = lexChain(casperString);
    const positionedNodes = positionNodes(lexedChain);
    let tokens = positionedNodes ? positionedNodes : lexedChain;
    const arranged = positionedNodes;
    let nodes = [];
    let edges = [];
    let sidechains = [];
    let linearAnnotations = [];
    let repeatingUnit = false;
    let repeatingUnitToken = null;
    let currentId = 1;

    tokens.forEach((token) => parseToken(token));
    let repeatingUnitEnd = currentId-1;
    
    let sideChainPos = 0;

    while(sideChainPos < sidechains.length)
    {
        let sideChainTokens = sidechains[sideChainPos].content;
        sideChainTokens.forEach((token) => {
            if(token.type === 'lnk') { token.sidelnk = true};
            parseToken(token)
        });
        
        edges[edges.length-1].to = sidechains[sideChainPos].connection
        sideChainPos++;
    }

    let linearAnnotationPos = 0;
    while(linearAnnotationPos < linearAnnotations.length)
    {
        handleLinearAnnotation(linearAnnotations[linearAnnotationPos]);
        linearAnnotationPos++;
    }

    if(repeatingUnit)
    {
        let front_symbol = genSVG("start-rep", "white", false,true);
        let end_symbol = genSVG("end-rep", "white", false, true);
        let front_node = {id:0, x:repeatingUnitToken.startx*100, y:0, nodeType:'shape', shape:"image", image:front_symbol.img, svg:front_symbol.svg};
        let end_node = {id:currentId, x:repeatingUnitToken.endx*100, y:0, nodeType:'shape', shape:"image", image:end_symbol.img, svg:end_symbol.svg};
        const finalResidue = nodes.find(node => node.id === repeatingUnitEnd);
        let edgeLabel = (finalResidue.conn_val==='a' ? 'α' : 'β') + repeatingUnitToken.first_number;
        let front_chain = {from:0, to:1, label:edgeLabel, sidelnk:false, dashes: nodes[nodes.length-1].conn_val==='a' ? [] : [5, 10]};
        let end_chain = {from:repeatingUnitEnd, to:currentId, dashes: nodes[nodes.length-1].conn_val==='a' ? [] : [5, 10]};
        nodes.push(...[front_node, end_node]);
        edges.push(...[front_chain, end_chain]);
    }

    function parseToken(token)
    {
        switch (token.type)
        {
            case "rep":
                repeatingUnit = true;
                repeatingUnitToken = token;
                break;
            case "com":
                linearAnnotations.push({content:token, connection:currentId});
                break;
            case "sub":
                linearAnnotations.push({content:token, connection:currentId-1}); //to same node
                break;
            case "res":
                handleResidue(token);
                break;
            case "lnk":
                handleLink(token);
                break;
            case "brc":
                sidechains.push({content:token.content, connection:currentId}); 
                break;
        }
    }

    function handleResidue(token)
    {
        let residue;
        if(token.text in resmap){
            residue = resmap[token.text];
        } else {
            residue = null;
        }
        let img_selected, img_unselected;
        if(residue)
        {
            const addLText = token?.abs === 'L';
            img_selected = genSVG(residue.shape, residue.colour, addLText, true, true);
            img_unselected = genSVG(residue.shape, residue.colour, addLText, true);
        } else {
            img_selected = genSVG("missing", "white", false, true, true);
            img_unselected = genSVG("missing", "white", false, true);
        }
        let res_node = {id:currentId,x:token.x*100, y:token.y*100, nodeType:'shape', shape:"image", 
            image:{unselected: img_unselected.img, selected:img_selected.img}, svg:img_unselected.svg, 
            shapeProperties:{borderDashes:[15,5], interpolation:false}, conn_val:token.ano, residue:token.text};
        token.id = currentId;
        currentId++;
        nodes.push(res_node);
    }
/*
    function handleLink(token)
    {
        let linkSymbol = 
        let edgeLabel = (nodes[nodes.length-1].conn_val==='a' ? 'α' : 'β')  + token.to;
        let res_edge = {sidelnk:token.sidelnk?true:false, from:nodes[nodes.length-1].id, to:currentId, label:edgeLabel, dashes: nodes[nodes.length-1].conn_val==='a' ? [] : [5, 10]};
        edges.push(res_edge);
    }*/
function handleLink(token)
    {
        // Grab the last node safely, even if the array is empty
        const connVal = nodes.at(-1)?.conn_val;

        // α if 'a', β if 'b', otherwise empty
        const edgeConf =
            connVal === 'a' ? 'α'
             : connVal === 'b' ? 'β'
             : '';            // <-- default
        let edgeLabel =  (token.to.length>2? token.to: edgeConf  + "  "+ token.to);
        let res_edge = {sidelnk:token.sidelnk?true:false, from:nodes[nodes.length-1].id, 
            to:currentId, label:edgeLabel, dashes: nodes[nodes.length-1].conn_val==='a' ? [] : [5, 10]};
        edges.push(res_edge);
    }
    

   /* function handleLinearAnnotation(token)
    {
        let com_node = {id:currentId, x:token.content.x*100, y:token.content.y*100, nodeType:'text', label:token.content.comment, shape: 'box', color:{border: '#000000', background:'#FFFFFF'}, highlight: {border: '#FAFAFA',background: '#D2E5FF'}, widthConstraint: {maximum:200}};
        let com_edge = {to:currentId, from:token.connection};
        nodes.push(com_node);
        edges.push(com_edge);
        currentId++;
    }*/
    function handleLinearAnnotation(token)
    {
        let com_node = {id:currentId, x:token.content.x*100, y:token.content.y*100, nodeType:'text', 
            label:token.content.comment, shape: 'box', color:{border: '#000000', background:'#FFFFFF'}, 
            highlight: {border: '#FAFAFA',background: '#D2E5FF'}, widthConstraint: {maximum:200}};
        let com_edge = {to:currentId, from:token.connection};
        nodes.push(com_node);
        edges.push(com_edge);
        currentId++;
    }
    return [nodes, edges, arranged];
}

function positionNodes(tokens)
{
    let conn3 = false;

    let repeatingUnitToken = null;
    function processChain(chain)
    {
        let tokenList = chain.content;
        let connection = chain.conPos;
        let chaingroup = {connection:connection, children:[], tokens:[]};
        let curPos = {x:0, y:0};
        let conPos = {x:0, y:0};

        for(let i = 0; i < tokenList.length; i++){    
            if(tokenList[i].type == 'res' || (tokenList[i].type === 'com' && tokenList[i].seen)){
                tokenList[i].pos = {...curPos};
                chaingroup.tokens.push(tokenList[i]);
                curPos.x += 1;
                curPos.y += 0;
                conPos = {...curPos}; //copy 
            } else if (tokenList[i].type === 'brc') {
                chaingroup.children.push({conPos:conPos, content:tokenList[i].content})  //set brc as a CHILD
            } else if (tokenList[i].type === 'rep') {
                repeatingUnitToken = tokenList[i];
            } else if (tokenList[i].type === 'com') {
                tokenList[i].seen = true;
                chaingroup.children.push({conPos:conPos, content:[tokenList[i]]}) //set comment as a CHILD
            }  else if(tokenList[i].type === 'sub' && tokenList[i].seen){ //second time processed
                //set the relative postion of this node
               // curPos.y -= 1.5; //but annotations above the line - can break
                //curPos.x -=1; //move back one in x-direction for previous residue
                tokenList[i].pos = {...curPos};//copy 
                chaingroup.tokens.push(tokenList[i]); //push current node
                curPos.x += 1;
                conPos = {...curPos};
            } 
            else if (tokenList[i].type === 'sub') { //first time processed
                tokenList[i].seen = true;
                conPos.x -= 1;
                chaingroup.children.push({conPos:conPos, content:[tokenList[i]]}) //set substituent as a CHILD
                conPos = {...curPos}; //copy 
            }
        }
        chaingroup.len = chaingroup.tokens.length;
        chaingroup.up = 0;
        chaingroup.down = 0;
        return chaingroup;
    }

    let mainParentChain = processChain({conPos:{x:0, y:0}, content:tokens});

    function recursiveProcess(chain, mainChain = false)
    {
        if (chain.children.length === 0){ //if no children/branches, straight line
            chain.up = 1
            chain.down = -1
            return
        }

        chain.children = chain.children.map(child => {
            let processedChild = processChain(child)
            recursiveProcess(processedChild) //recursice call
            return processedChild;
        })
        //note here that children are processed from left to right, so order is fine.
        
        let parentUpRight = -Infinity;
        let parentDownRight = -Infinity;
        let parentUp = 0; //no chains above
        let parentDown = 0; //no chains below
        chain.children = chain.children.map(child => {
            if(parentDownRight < child.connection.x){  //a connection at this point down hasn't been made
                child.yoffset = -child.up; //calculate our ideal minimum yoffset
                if(child.connection.x - child.len < parentDownRight){ //if our chain is long enough to collide 
                    child.yoffset += parentDown+1;
                }
                parentDown = Math.min(parentDown, child.yoffset+child.down);
                parentDownRight = child.connection.x; //jump the connected area
            } else if (parentUpRight < child.connection.x) { //a connection at this point up hasn't been made
                //done the flip
                flipLeaves(child);
                child.yoffset = -child.down; //lower dimension of the child
                if(child.connection.x - child.len < parentUpRight){
                    child.yoffset += parentUp-1;
                }
                child.direction = 'down';
                parentUp = Math.max(parentUp, child.yoffset+child.up);
                // parentUp = parentUp + child.yoffset + child.up;
                parentUpRight = child.connection.x;
            } else {
                conn3 = true;
            }
            return child;
        })

        //set the parent dimensions
        chain.down = Math.min(-1,parentDown);
        chain.up = Math.max(1,parentUp);
    }
    //arrange all the chains
    recursiveProcess(mainParentChain, true);
    //if false here do something else
    mainParentChain.yoffset = 0;
    mainParentChain.xoffset = 0;

    function flipLeaves(parent){
        if(parent.children.length === 0){
            return
        }

        parent.children.forEach(child => {
            flipLeaves(child);
            child.yoffset *= -1;
        })

        let tmp = parent.down;
        parent.down = -parent.up;
        parent.up = -tmp;
    }

    function placeNodes(chain)
    {
        chain.tokens.forEach(token => {
            token.x = token.pos.x + chain.xoffset;
            token.y = token.pos.y - chain.yoffset;
        })
        
        //propogate the offsets down the tree
        chain.children.forEach(child => {
            child.yoffset += chain.yoffset;
            child.xoffset = chain.xoffset + (child.connection.x - (child.len-1));
            placeNodes(child);
        })
    }
    
    placeNodes(mainParentChain);
    
    if(repeatingUnitToken){
        repeatingUnitToken.startx = -1;
        repeatingUnitToken.endx = mainParentChain.len;
    }
    if(!conn3){
        return tokens;
    } else {
        return false;
    }
}

export {parseString, genSVG, formatString};